import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Replacing a Part List",
description: "Replace a Freon part list with a custom Svelte accordion component. Learn to build StaffAccordion.svelte, wire it to PartListReplacerBox, manage focus and refresh, and register it for use in projections.",
tags: [ "Freon", "Svelte", "external components", "PartListReplacerBox", "StaffAccordion", "Accordion", "RenderComponent", "AST.change", "MobX", "projections", "CourseSchedule"] ,
modifiedTime: "2025-11-07T18:12:52.262Z",
publishedTime: "2025-11-07T17:20:18.642Z"
    }
  };
};